import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * The same `cn()` as apps/portal's, deliberately identical.
 *
 * `twMerge` is what lets a caller override a component's own classes without
 * specificity games — `<Button className="h-14">` beats the variant's `h-16`
 * because the later Tailwind class wins the merge, not because of source order.
 * Every component copied from portal assumes that behaviour, so a clsx-only
 * `cn()` would silently fork all of them.
 */
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
